export default __webpack_public_path__ + "static/media/logo-name.de145d71.svg";